module.exports = __webpack_public_path__ + "img/colored-square.c246c8aa.svg";